import { render, staticRenderFns } from "./UploadPaymentModal.vue?vue&type=template&id=65379e72&"
import script from "./UploadPaymentModal.vue?vue&type=script&lang=js&"
export * from "./UploadPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports